import { DefaultOptions } from '@tanstack/react-query';

export const queryConfig = {
  queries: {
    // throwOnError: true,
    refetchOnWindowFocus: false,
    // retry on error 1 time
    retry: 1,
    // 1 minute
    staleTime: 1000 * 60,
  },
} satisfies DefaultOptions;
